import { queryOptions } from '@tanstack/react-query';
import { REVIEW_QUERY_KEYS } from './keys';
import { reviewAPIClient } from '../reviewAPIClient';
import type {
  GetProductReviewsRequest,
  GetProductReviewsResponse,
  GetAIProductReviewsRequest,
  GetAIProductReviewsResponse,
  GetCuratedReviewsRequest,
  GetCuratedReviewsResponse,
  GetMyReviewsRequest,
  GetMyReviewsResponse,
  GetReviewCreditAmountsRequest,
  GetReviewCreditAmountsResponse,
  GetReviewCreditEligibilityResponse,
  GetReviewCreditSummaryRequest,
  GetReviewCreditSummaryResponse,
  ReviewStatisticsRequest,
  ReviewStatisticsResponse,
} from './types';

export const REVIEW_QUERIES = {
  getProductReviews: (productId: number, params?: Omit<GetProductReviewsRequest, 'productId'>) =>
    queryOptions<GetProductReviewsResponse>({
      queryKey: REVIEW_QUERY_KEYS.getProductReviews(productId, params),
      queryFn: () => reviewAPIClient.getProductReviews(productId, params),
    }),

  getAIProductReviews: (productId: number, params?: Omit<GetAIProductReviewsRequest, 'productId'>) =>
    queryOptions<GetAIProductReviewsResponse>({
      queryKey: REVIEW_QUERY_KEYS.getAIProductReviews(productId, params),
      queryFn: () => reviewAPIClient.getAIProductReviews(productId, params),
    }),

  getCuratedReviews: (params?: GetCuratedReviewsRequest) =>
    queryOptions<GetCuratedReviewsResponse>({
      queryKey: REVIEW_QUERY_KEYS.getCuratedReviews(params),
      queryFn: () => reviewAPIClient.getCuratedReviews(params),
    }),

  getMyReviews: (params?: GetMyReviewsRequest) =>
    queryOptions<GetMyReviewsResponse>({
      queryKey: REVIEW_QUERY_KEYS.getMyReviews(params),
      queryFn: () => reviewAPIClient.getMyReviews(params),
    }),

  getReviewCreditAmounts: (params?: GetReviewCreditAmountsRequest) =>
    queryOptions<GetReviewCreditAmountsResponse>({
      queryKey: REVIEW_QUERY_KEYS.getReviewCreditAmounts(params),
      queryFn: () => reviewAPIClient.getReviewCreditAmounts(params),
    }),

  getReviewCreditEligibility: (productId: number) =>
    queryOptions<GetReviewCreditEligibilityResponse>({
      queryKey: REVIEW_QUERY_KEYS.getReviewCreditEligibility(productId),
      queryFn: () => reviewAPIClient.getReviewCreditEligibility({ productId }),
    }),

  getReviewCreditSummary: (params?: GetReviewCreditSummaryRequest) =>
    queryOptions<GetReviewCreditSummaryResponse>({
      queryKey: REVIEW_QUERY_KEYS.getReviewCreditSummary(params),
      queryFn: () => reviewAPIClient.getReviewCreditSummary(params),
    }),

  getReviewStatistics: (params: ReviewStatisticsRequest) =>
    queryOptions<ReviewStatisticsResponse>({
      queryKey: REVIEW_QUERY_KEYS.getReviewStatistics(params),
      queryFn: () => reviewAPIClient.getReviewStatistics(params),
    }),
};
